import { grey } from "@mui/material/colors";

interface TableCellStyles {
  color?: string;
  width?: number | string;
  maxWidth?: number | string;
  minWidth?: number | string;
  border?: string;
  position?: any;
  bottom?: any;
  right?: any;
  background?: any;
  padding?: any;
  borderRadius?: any;
  height?: any;
  display?: any;
  flexDirection?: any;
  justifyContent?: any;
  backgroundColor?: any;
  alignItems?: any;
  maxHeight?: any;
  marginRight?: any;
  textAlign?: any;
  top?: any;
  left?: any;
  overflow?: any;
  marginBottom?: any;
  minHeight?: any;
  margin?: any;
}

export const addVideoBoxStyles: TableCellStyles = {
  padding: "10px 20px",
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
};
export const videoListBoxStyles: TableCellStyles = {
  padding: "1rem",
  height: "85%",
  display: "flex",
  flexDirection: "column",
  justifyContent: "space-between",
};
export const videoListTableStyle: TableCellStyles = {
  display: "flex",
  flexDirection: "column",
  maxHeight: "65vh",
  height: "100%",
};

// TableCell styles for various columns
export const checkboxCellStyle: TableCellStyles = {
  color: grey[500],
  width: 50,
  maxWidth: 50,
  minWidth: 50,
};

export const videoCellStyle: TableCellStyles = {
  color: grey[500],
  width: 230,
  maxWidth: 230,
  minWidth: 230,
};

export const descriptionCellStyle: TableCellStyles = {
  color: grey[500],
  width: 370,
  maxWidth: 370,
  minWidth: 370,
};

export const likesViewsDateCommentsCellStyle: TableCellStyles = {
  color: grey[500],
  width: 120,
  maxWidth: 120,
  minWidth: 120,
};

export const checkBoxBodyRowCellStyles: TableCellStyles = {
  position: "relative",
  width: 50,
  maxWidth: 50,
  minWidth: 50,
};

export const thumbnailDuraionStyles: TableCellStyles = {
  position: "absolute",
  bottom: "5px",
  right: "5px",
  background: "rgba(0, 0, 0, 0.5)",
  color: "white",
  padding: "2px 5px",
};
export const thumbnailPlayListStyles: TableCellStyles = {
  position: "absolute",
  top: "0px",
  right: "0px",
  height: "100%",
  width: "30%",
  background: "rgba(0, 0, 0, 0.5)",
  color: "white",
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "center",
};
export const inputVideoIdStyles: TableCellStyles = {
  height: 40,
  width: "50%",
  textAlign: "center",
};

export const thumbnailUploadStyles: TableCellStyles = {
  position: "relative",
  width: "70%",
  height: "70%",
  maxHeight: "100%",
};

export const videoPlayerContaierStyles: TableCellStyles = {
  position: "relative",
  overflow: "hidden",
  width: "100%",
  height: "42.5vh",
  border: "1px solid gray",
  marginBottom: "20px",
};
export const videoPlayerStyles: TableCellStyles = {
  position: "absolute",
  top: 0,
  left: 0,
  width: "100%",
  height: "100%",
};

export const AddPlayListBoxStyles: TableCellStyles = {
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
};
export const ViewPlayListBoxStyles: TableCellStyles = {
  display: "flex",
  alignItems: "center",
  // justifyContent: "flex-start",
};

export const CancleIconButton: TableCellStyles = {
  color: "gray",
  backgroundColor: "white",
  borderRadius: "50%",
};

// ** ViewPlayList Container **

export const ViewPlayListMainContainerStyles: TableCellStyles = {
  display: "flex",
  flexDirection: "column",
  height: "100%",
  maxHeight: "90.5vh",
  padding: 1,
};

export const ViewCancleIconButton: TableCellStyles = {
  color: "gray",
  backgroundColor: "white",
  borderRadius: "50%",
  width: "15px",
  height: "15px",
};

export const PlayListvideoListTableStyle: TableCellStyles = {
  display: "flex",
  flexDirection: "column",
  maxHeight: "65vh",
  minHeight: "-webkit-fill-available",
  height: "100%",
};

export const PlayListvideoCellStyle: TableCellStyles = {
  color: grey[500],
  width: 100,
  maxWidth: 100,
  minWidth: 100,
};

export const PlayListdescriptionCellStyle: TableCellStyles = {
  color: grey[500],
  width: 130,
  maxWidth: 130,
  minWidth: 120,
};

// ** used in EditPlayList And AddPlayList **
export const PlayListCoverPicStyles: TableCellStyles = {
  position: "relative",
  width: 165,
  height: 115,
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
};

// Common
export const HeightLocked100: TableCellStyles = {
  height: "100%",
  minHeight: "100%",
  maxHeight: "100%",
};

export const PositionTopRight: TableCellStyles = {
  position: "absolute",
  top: 0,
  right: 0,
};

export const tableCheckBox: TableCellStyles = {
  color: grey[500],
  width: 5,
  maxWidth: 5,
  minWidth: 5,
  margin: "auto",
};
